import { type CollapseProps as CollapsePropsV5, Collapse as _Collapse } from 'antd';

import { CollapseV5 } from './Collapse.style';

type CollapseProps = CollapsePropsV5;

const Collapse: React.FunctionComponent<CollapseProps> = props => {
  return <CollapseV5 {...props} />;
};

const CollapseNamespace = Object.assign(Collapse, { Panel: _Collapse.Panel });

export { CollapseNamespace as Collapse };
